<template>
  <div v-if="this.integrationCustomStatus.loading" style="display: flex; justify-content: center; align-items: center; min-height: 80vh;">
    <i class="fas fa-spinner fa-spin" style="font-size: 40px;"></i>
  </div>
  <div v-else-if="this.integrationCustomStatus.error">
    <ErrorPage />
  </div>
  <div v-else-if="this.integrationCustomStatus.notFound">
    <NotFoundPage />
  </div>
  <div v-else class="row">
    <div class="col-12">
      <div class="integration__header">
        <el-button
            class="btn-redirect-integration" 
            type="text"
            @click="$router.replace('/integrations')" 
            icon="el-icon-arrow-left">Back</el-button>
        <div class="d-flex flex-column">
          <h3 class="mb-1 emm__page-heading text-uppercase">
          {{ this.integrationCustom.custom_name || this.integrationCustom.name }}
          </h3>
          <span class="emm__page-sub-heading">Get your emails to the inbox—where they belong</span>
        </div>
      </div>
      <!-- <card bodyClasses="rounded-2" class="overflow-hidden rounded-2 mb-0 mt-5">
        <h4>Campaigns Attatched</h4>
      </card> -->
      <card bodyClasses="rounded-2" class="overflow-hidden rounded-2 mb-0 mt-5">
        <div class="d-flex align-items-end justify-content-between">
          <h4>{{ this.integrationCustom.custom_name || this.integrationCustom.name }} configuration</h4>
          <base-button id="btnSaveIntegration" @click="saveIntegrationSettingslocal"
            :disabled="isLoading || !isValidConfiguration" class="m-0">Save</base-button>
        </div>
        
        <div style="gap: 12px" class="d-flex flex-column mt-4">
          <base-checkbox v-model="integrationDetails.enable_sendgrid">Enable {{ this.integrationCustom.custom_name || this.integrationCustom.name }}</base-checkbox>

          <div class="leadconnector-theme">
            <!-- gohighlevel -->
            <div class="leadconnector-theme" style="margin: 5px 0;" v-if="slugName == 'gohighlevel'">
              <el-tabs class="leadconnector-theme" v-model="integrationVersion" type="border-card">
                <el-tab-pane name="2" :disabled="integrationVersion == '1' && isLoading">
                  <span slot="label">Full Integration</span>
                  <div class="row">
                    <div class="col-md-6">
                      <div style="margin-left: 4px;">
                        <p v-if="ghlV2Connected" class="leadconnector-theme">You Have Connected Contact Sync</p>
                        <p class="leadconnector-theme" v-else>You Have Not Yet Connected Contact Sync</p>
                      </div>
                      <div :style="!ghlV2CreatedIframe && ghlV2AgencyConnected && $global.idsys == $global.masteridsys ? { marginTop: '10px' } : {}">
                        <base-button id="btnConnectDisconnectGhlv2" :disabled="isLoadingConnectDisconnectGhlv2" @click="connectDisconnectGhlv2">
                          {{ btnConnectDisconnectGhlv2Text }}
                          <i v-if="isLoadingConnectDisconnectGhlv2" class="fas fa-spinner fa-spin ml-2" style="font-size: 20px;"></i>
                        </base-button>
                      </div>
                    </div>



                    <div class="col-md-6 divider-ghl2" v-if="isInRootSystemUser && (isShowLeadConnectorIframeSection(1) || isShowLeadConnectorIframeSection(2))">
                      <div v-if="isShowLeadConnectorIframeSection(1)">
                        <div style="margin-left: 4px;">
                          <p class="leadconnector-theme" v-if="ghlV2CreatedIframe">You Have Created a Single Sign On Link ({{ labelSSOLinkYourSubAccount }})</p>
                          <p class="leadconnector-theme" v-else>You Have Not Yet Created a Single Sign On Link ({{ labelSSOLinkYourSubAccount }})</p>
                        </div>
                        <div style="display: flex; justify-content: space-between; align-items: center; gap: 16px;">
                          <div :style="!ghlV2CreatedIframe && ghlV2AgencyConnected && $global.idsys == $global.masteridsys ? { width: '100%' } : {}">
                            <base-button :style="!ghlV2CreatedIframe && ghlV2AgencyConnected && $global.idsys == $global.masteridsys ? { width: '100%' } : {}" id="btnCreateDeleteIframeGhlv2Text" @click="createDeleteIframeGhlv2" :disabled="isLoadingCreateDeleteIframeGhlV2">
                              {{ btnCreateDeleteIframeGhlv2Text }}
                              <i v-if="isLoadingCreateDeleteIframeGhlV2" class="fas fa-spinner fa-spin ml-2" style="font-size: 20px;"></i>
                            </base-button>
                          </div>
                          <div style="width: 100%;" class="form-group has-label" v-if="!ghlV2CreatedIframe && ghlV2AgencyConnected && this.$global.idsys == this.$global.masteridsys">
                            <el-select
                              style="width: 100%; margin-top: 10px; border: 2px solid black; border-radius: 9px; color: black;"
                              class="select-primary"
                              size="large"
                              placeholder="Select Client"
                              filterable
                              default-first-option
                              v-model="selects.ghlv2SubAccount"
                              @visible-change="onSelectGhlV2SubAccountVisible"
                              ref="selectGhlV2SubAccount">
                              <el-option
                                v-for="item in ghlV2ListSubAccounts"
                                class="select-primary"
                                :value="item.id"
                                :label="item.name"
                                :key="item.id">
                              </el-option>
                              <el-option v-if="paginationGhlV2SubAccount.isFetch && !paginationGhlV2SubAccount.isComplete" value="loading" label="Loading...." disabled>
                              </el-option>
                            </el-select>
                          </div>
                        </div>
                      </div>
                      
                      <el-divider v-if="isShowLeadConnectorIframeSection(1) && isShowLeadConnectorIframeSection(2)"></el-divider>
                      
                      <div v-if="isShowLeadConnectorIframeSection(2)">
                        <div style="margin-left: 4px;">
                          <p class="leadconnector-theme" v-if="ghlV2CreatedIframeYourAccount">You Have Created a Single Sign On Link ({{ labelSSOLinkYourAccount }})</p>
                          <p class="leadconnector-theme" v-else>You Have Not Yet Created a Single Sign On Link ({{ labelSSOLinkYourAccount }})</p>
                        </div>
                        <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 16px; align-items: center;">
                          <base-button id="btnCreateDeleteIframeGhlv2TextYourAccount" :disabled="isLoadingCreateDeleteIframeGhlv2YourAccount" style="width: 100%;" @click="createDeleteIframeGhlv2YourAccount">
                            {{ btnCreateDeleteIframeGhlv2TextYourAccount }}
                            <i v-if="isLoadingCreateDeleteIframeGhlv2YourAccount" class="fas fa-spinner fa-spin ml-2" style="font-size: 20px;"></i>
                          </base-button>
                        </div>
                      </div>
                    </div>
                  </div>
                </el-tab-pane>
                <el-tab-pane name="1">
                  <span slot="label">API Only</span>
                  <label class="mb-1 leadconnector-theme">Enter your API Key</label>
                  <el-input type="text" clearable label="Enter your API Key" placeholder="GJYEzzse345673htj"
                    class="flex-grow-1 mb-0" v-model="userApiKey" aria-controls="datatables">
                  </el-input>
                </el-tab-pane>
              </el-tabs>
            </div>
            <!-- gohighlevel -->
            
            <!-- sendjim -->
            <div v-else-if="slugName === 'sendjim'" class="leadconnector-theme" style="margin: 5px 0;">
              <div class="has-label" style="margin-bottom: 10px;">
                <label class="mb-0">OAuth Redirect URL</label>
                <el-input :value="sendjimCallbackUrl" readonly class="flex-grow-1 mb-0 input__transparent">
                  <el-button slot="append" icon="el-icon-document-copy" @click="copyToClipboard(sendjimCallbackUrl)"></el-button>
                </el-input>
                <small>Whitelist this URL in your SendJim app settings.</small>
              </div>
              <div class="has-label" style="margin-bottom: 10px;">
                <label class="mb-0">Client ID <span style="color: var(--danger);">*</span></label>
                <el-input v-model="userApiKey" type="text" clearable placeholder="Enter your SendJim Client ID" class="flex-grow-1 mb-0 input__transparent" aria-controls="datatables"></el-input>
              </div>
              <div class="has-label" style="margin-bottom: 10px;">
                <label class="mb-0">Client Secret <span style="color: var(--danger);">*</span></label>
                <el-input v-model="sendjimClientSecret" type="password" show-password clearable placeholder="Enter your SendJim Client Secret" class="flex-grow-1 mb-0 input__transparent" aria-controls="datatables"></el-input>
              </div>
              <div class="d-flex align-items-center" style="gap: 8px;">
                <base-button :disabled="isLoading" @click.native="saveIntegrationSettingslocal">Save Client ID</base-button>
                <base-button v-if="!sendjimConnected" :disabled="isLoadingConnectDisconnectSendjim" @click.native="connectSendJim">Connect</base-button>
                <base-button v-else :disabled="isLoadingConnectDisconnectSendjim" @click.native="disconnectSendJim">Disconnect</base-button>
              </div>
            </div>
            <!-- sendjim -->

            <!-- when not zapier / agencyzoom / sendjim -->
            <base-input v-else-if="slugName !== 'zapier' && slugName !== 'agencyzoom' && slugName !== 'sendjim'" type="text" clearable label="Enter your API Key" placeholder="GJYEzzse345673htj"
              class="flex-grow-1 mb-0" v-model="userApiKey" aria-controls="datatables">
            </base-input>
            <!-- when not zapier -->
          </div>

          <!-- zapier -->
          <div class="integration-webhook-section" v-if="slugName === 'zapier'">
            <div class="integration-webhook-section__header">
              <div>
                <h5 class="integration-webhook-section__title">Zapier Webhooks</h5>
                <p class="integration-webhook-section__subtitle">
                  Connect one or more Zapier webhook URLs to receive lead data in real time.
                </p>
              </div>
            </div>

            <div class="integration-webhook-section__body">
              <label class="integration-webhook-section__label">Webhook URLs</label>
              <p class="integration-webhook-section__helper">
                You can add multiple webhook URLs. Each URL will receive the same payload.
              </p>

              <div class="integration-webhook-list">
                <div
                  v-for="(url, index) in zapier"
                  :key="index"
                  class="integration-webhook-item"
                >
                  <div class="integration-webhook-item__main">
                    <span class="integration-webhook-item__badge">
                      {{ index + 1 }}
                    </span>
                    <div class="integration-webhook-item__fields">
                      <el-input
                        type="text"
                        clearable
                        label="Enter your Webhook URL"
                        placeholder="https://hooks.app.com/hooks/catch/....."
                        class="integration-webhook-item__input"
                        v-model="zapier[index]"
                        aria-controls="datatables"
                        @keyup.native="addWebhookUrlKeyupEnter($event, 'zapier')"
                        :ref="'webhookInput-' + index"
                      >
                      </el-input>
                      <el-input
                        type="text"
                        clearable
                        placeholder="Webhook Label (optional)"
                        class="integration-webhook-item__label-input"
                        v-model="zapierLabels[index]"
                      >
                      </el-input>
                    </div>
                  </div>
                  <div class="integration-webhook-item__actions">
                    <el-button
                      v-if="index !== 0 || zapier.length > 1"
                      type="text"
                      size="mini"
                      @click="removeWebhookUrl(index, 'zapier')"
                    >
                      <i class="fa-solid fa-minus mr-1"></i> Remove
                    </el-button>
                  </div>
                </div>
              </div>

              <div class="integration-webhook-section__footer">
                <el-button
                  type="primary"
                  size="mini"
                  icon="el-icon-plus"
                  @click="addWebhookUrl('zapier')"
                >
                  Add Webhook URL
                </el-button>
              </div>
            </div>
          </div>
          <div class="d-flex mt-4">
              <base-checkbox class="mr-3" v-if="slugName === 'zapier'" v-model="sendTestZapier">Send Test Data</base-checkbox>
                <div class="d-flex align-items-center" v-if="slugName === 'zapier'">
                 <el-button
                    class="mr-2 mb-1"
                    :icon="'el-icon-view'"
                    @click="onViewExampleData"
                    style="width: 10px; height: 10px; padding: 0; background-color: transparent; color: var(--text-primary-color); border: none;"></el-button>
                    <el-button type="text" @click="onViewExampleData" style="margin-left: 0px;">View Example Data</el-button>
                  </div>
          </div>
          <p class="m-0" v-if="slugName === 'zapier'">* check and click save to send dummy data to your webhook</p>
          <div v-if="slugName === 'zapier'">
            <p class="m-0 pl-2"><strong>Need help setting up your webhook?</strong> Check out the documentation:</p>
            <p class="m-0 pl-2"><a href="https://api.slack.com/messaging/webhooks" target="_blank">Slack</a> | <a href="https://developers.make.com/custom-apps-documentation/app-structure/modules/instant-trigger" target="_blank">Make</a> | <a href="https://help.zapier.com/hc/en-us/articles/8496083355661-How-to-get-started-with-Webhooks-by-Zapier" target="_blank">Zapier</a> | <a href="https://www.pabbly.com/beginners-guide-to-webhook-integration-with-pabbly-connect/" target="_blank">Pabbly</a> | <a href="https://www.zoho.com/developer/help/extensions/automation/webhooks.html" target="_blank">ZoHo</a> | <a href="https://developers.hubspot.com/docs/guides/api/app-management/webhooks" target="_blank">HubSpot</a></p>
          </div>
          
          <!-- zapier -->

          <!-- agency zoom -->
          <div class="integration-webhook-section" v-if="slugName === 'agencyzoom'">
            <div class="integration-webhook-section__header">
              <div>
                <h5 class="integration-webhook-section__title">AgencyZoom Webhooks</h5>
                <p class="integration-webhook-section__subtitle">
                  Connect one or more AgencyZoom webhook URLs to receive lead data in real time.
                </p>
              </div>
            </div>

            <div class="integration-webhook-section__body">
              <label class="integration-webhook-section__label">Webhook URLs</label>
              <p class="integration-webhook-section__helper">
                You can add multiple webhook URLs. Each URL will receive the same payload.
              </p>

              <div class="integration-webhook-list">
                <div
                  v-for="(url, index) in agencyZoomWebhook"
                  :key="index"
                  class="integration-webhook-item"
                >
                  <div class="integration-webhook-item__main">
                    <span class="integration-webhook-item__badge">
                      {{ index + 1 }}
                    </span>
                    <el-input
                      type="text"
                      clearable
                      label="Enter your Webhook URL"
                      placeholder="https://app.agencyzoom.com/v1/api/lead/webhook/....."
                      class="integration-webhook-item__input"
                      v-model="agencyZoomWebhook[index]"
                      aria-controls="datatables"
                      @keyup.native="addWebhookUrlKeyupEnter($event, 'agencyzoom')"
                      :ref="'webhookInputAgency-' + index"
                    >
                    </el-input>
                  </div>
                  <div class="integration-webhook-item__actions">
                    <el-button
                      v-if="index !== 0 || agencyZoomWebhook.length > 1"
                      type="text"
                      size="mini"
                      @click="removeWebhookUrl(index, 'agencyzoom')"
                    >
                      <i class="fa-solid fa-minus mr-1"></i> Remove
                    </el-button>
                  </div>
                </div>
              </div>

              <div class="integration-webhook-section__footer">
                <el-button
                  type="primary"
                  size="mini"
                  icon="el-icon-plus"
                  @click="addWebhookUrl('agencyzoom')"
                >
                  Add Webhook URL
                </el-button>
              </div>
            </div>
          </div>
          <base-checkbox v-if="slugName === 'agencyzoom'" v-model="sendTestAgencyZoom">Send Test Data</base-checkbox>
          <p class="m-0" v-if="slugName === 'agencyzoom'">* check and click save to send dummy data to your webhook</p>
          <!-- <div v-if="slugName === 'agencyzoom'">
            <p class="m-0 pl-2"><strong>Need help setting up your webhook?</strong> Check out the documentation:</p>
            <p class="m-0 pl-2"><a href="https://api.slack.com/messaging/webhooks" target="_blank">Slack</a> | <a href="https://developers.make.com/custom-apps-documentation/app-structure/modules/instant-trigger" target="_blank">Make</a> | <a href="https://help.zapier.com/hc/en-us/articles/8496083355661-How-to-get-started-with-Webhooks-by-Zapier" target="_blank">Zapier</a> | <a href="https://www.pabbly.com/beginners-guide-to-webhook-integration-with-pabbly-connect/" target="_blank">Pabbly</a> | <a href="https://www.zoho.com/developer/help/extensions/automation/webhooks.html" target="_blank">ZoHo</a> | <a href="https://developers.hubspot.com/docs/guides/api/app-management/webhooks" target="_blank">HubSpot</a></p>
          </div> -->
          <!-- agency zoom -->

          <!-- mailboxpower -->
          <div v-if="slugName === 'mailboxpower'" class="d-flex" style="flex-direction: column; gap: 12px; margin-top: 25px" >
              <span style="display: flex; align-items: center;gap: 8px">
               <el-button
                   size="medium"
                   icon="el-icon-unlock"
                   @click="redirectToLink(`https://mailboxpower.com/${refcode}`)"
                   circle
                
                   ></el-button> <span>If you do not have a {{ this.integrationCustom.custom_name || this.integrationCustom.name }} account, <a style="color: inherit !important;font-size: inherit;font-weight: bold;" :href="`https://mailboxpower.com/${refcode}`" target="_blank">Click Here</a> to create one</span>
               </span>
               <span style="display: flex; align-items: center;gap: 8px">
               <el-button
                   size="medium"
                   icon="el-icon-s-promotion"
                   @click="redirectToLink(`https://app.mailboxpower.com/demo/${refcode}`)"
                   circle
                   ></el-button> 
               <a style="color: inherit !important;font-size: inherit;font-weight: inherit" class="d-block" :href="`https://app.mailboxpower.com/demo/${refcode}`" target="_blank">Learn More about the Integration</a>
               </span>
          </div>
          <!-- mailboxpower -->
          
          <!-- kartra -->
          <base-input v-if="slugName === 'kartra'" type="text" clearable label="Enter your API Password"
            placeholder="GJYEzzse345673htj" class="flex-grow-1 mb-0" v-model="userApiPassword"
            aria-controls="datatables">
          </base-input>
          <!-- kartra -->
        </div>
        
        <div v-if="slugName === 'kartra'">
          <p class="mt-4 d-block"><strong>Note:</strong> When you click Save, this app will create the below custom
            fields in your Kartra account. These fields are Required for this connection to work properly.
            As per Kartra's policy, once a custom field is deleted, it cannot be recreated. Therefore, <span
            class="text-underline">Do NOT</span> delete or rename the below custom fields in your Kartra account.
            <strong style="cursor: pointer;" v-if="!showKartraCustomFields" @click="showKartraCustomFields = !showKartraCustomFields">show more</strong>
          </p>

          <ul v-show="showKartraCustomFields">
            <li>secondphone</li>
            <li>secondemail</li>
            <li>keyword</li>
            <li>secondaddress</li>
          </ul>
        </div>

        <!-- <div class="mt-lg-5 d-flex align-items-end justify-content-end">
          <base-button @click="saveIntegrationSettingslocal" :disabled="isLoading || !userApiKey"
            class="m-0">Save</base-button>
        </div> -->
        <!-- <div class="mt-4">
          <label class="d-block mb-0" for="contact-upload"
            >Upload your contact list</label
          >
       
          <form enctype="multipart/form-data">
          
            <div class="dropbox">
              <input
                id="contact-upload"
                type="file"
                :name="uploadFieldName"
                :disabled="isSaving"
                @change="
                  filesChange($event.target.name, $event.target.files);
                  fileCount = $event.target.files.length;
                "
                accept=".csv"
                class="input-file"
              />
              <p>
                Drag your csv file here to upload<br />or click to browse<br />
                <base-button
                  type="info"
                  round
                  icon
                  @click="show_helpguide('optoutlist')"
                >
                  <i class="fas fa-question"></i>
                </base-button>
              </p>
              <p v-if="isSaving">
                Please Wait, your file is being processed ...
              </p>
              <p v-if="isSuccess">Process finished successfully, Thank you!</p>
              <p v-if="isFailed">
                Whoops that did not work, please check your file for errors and
                try again
              </p>
            </div>
          </form>
        </div> -->

        <!-- clickfunnels -->
        <div v-if="slugName === 'clickfunnels'" style="margin-top: 8px; display: flex; flex-direction: column; gap: 8px;">
          <label class="mb-0">Subdomain</label>
          <el-input v-model="clickfunnels.subdomain" type="text" clearable label="Enter your subdomain"
            placeholder="richstone" class="flex-grow-1 mb-0 input__transparent"
            aria-controls="datatables">
            <template :slot="windowWidth > 576 && 'prepend'">https://</template>
            <template :slot="windowWidth > 576 && 'append'">.myclickfunnels.com</template>
          </el-input>
          <small v-if="windowWidth < 576" class="wrap-text">Example: https://{{ clickfunnels.subdomain ? clickfunnels.subdomain : 'yoursubdomain' }}.myclickfunnels.com</small>
          <label class="mb-0">Workspace ID</label>
          <el-input v-model="clickfunnels.workspaceId" type="text" clearable label="Enter your workspaces"
            placeholder="jWMWXZ" class="flex-grow-1 mb-0 input__transparent"
            aria-controls="datatables">
            <template :slot="windowWidth > 992 && 'prepend'">https://{{ clickfunnels.subdomain }}.myclickfunnels.com/account/workspaces/</template>
          </el-input>
          <small v-if="windowWidth < 992" class="wrap-text">Example: https://{{ clickfunnels.subdomain ? clickfunnels.subdomain : 'yoursubdomain' }}.myclickfunnels.com/account/workspaces/workspaceid</small>        
        </div>
        <!-- clickfunnels -->

        <!-- custom field only gohighlevel and clickfunnels -->
        <div v-if="slugName === 'clickfunnels' || slugName === 'gohighlevel'">
          <CheckboxCustomFields
              :classCheckbox="'checkbox-custom-fields-integrations'"
              :slug="slugName"
              :isLoadingCustomFieldsBySlug="isLoadingListCustomFieldsIntegration"
              :isErrorCustomFieldsBySlug="errorListCustomFieldsIntegration"
              :handleDefaultCustomFields="getCustomFields"
              :customFieldsBySlug="listCustomFieldsIntegration"
              :listValueFieldsIntegration="listValueCustomFieldsIntegration"
              :listValueFieldsIntegrationB2b="listValueCustomFieldsIntegrationB2b"
              :listValueFieldsIntegrationAdvance="listValueCustomFieldsIntegrationAdvance"
              :handleCheckItemCustomFields="handleCheckItemCustomFields"
              :isHideB2b="isHideB2b"
              :isHideAdvance="isHideAdvance"
              :handleCheckAllCustomFields="handleCheckAllCustomFields"
              :isCheckAllIntegrationGeneral="isCheckAllIntegrationGeneral"
              :isCheckAllIntegrationB2b="isCheckAllIntegrationB2b"
              :isCheckAllIntegrationAdvance="isCheckAllIntegrationAdvance"
          />
        </div>
        <!-- custom field only gohighlevel and clickfunnels -->

        <div  class="mt-5" style="font-size: 12px;">
          Note: Some of the links on this site are affiliate links, meaning we may earn a commission if you sign up or make a purchase through them. This helps support our work at no additional cost to you.
        </div>
      </card>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { Input,Button, Divider, Checkbox, MessageBox, Card, Tabs, TabPane, Select, Option } from 'element-ui'
import { SkeletonCheckbox, ErrorPage, NotFoundPage } from '../../components'
import { decryptData } from '../../helpers/crypto'
import CheckboxCustomFields from '../../components/CheckboxCustomFields.vue'

export default {
  components: {
    [Input.name] : Input,
    [Button.name]: Button,
    [Checkbox.name]: Checkbox,
    [Divider.name]: Divider,
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane,
    [Select.name]: Select,
    [Option.name]: Option,
    'el-card': Card,
    SkeletonCheckbox,
    CheckboxCustomFields,
    ErrorPage,
    NotFoundPage,
  },
  data() {
    return {
      basicExampleDataUrl: 'https://sitesettings-api-docs.vercel.app/agency/informations/send-test',
      ghlV2Connected: false,
      btnConnectDisconnectGhlv2Text: 'Activate Contact Sync',
      isLoadingConnectDisconnectGhlv2: false,

      ghlV2ListSubAccounts : [],
      ghlV2AgencyConnected: false,
      ghlV2CreatedIframe: false,
      btnCreateDeleteIframeGhlv2Text: 'Create SSO Link',
      isLoadingCreateDeleteIframeGhlV2: false,

      ghlV2CreatedIframeYourAccount: false,
      btnCreateDeleteIframeGhlv2TextYourAccount: 'Create SSO Link',
      isLoadingCreateDeleteIframeGhlv2YourAccount: false,

      integrationVersion: '1',
      userApiKey: '',
      userApiPassword: '',
      sendjimClientSecret: '',
      isLoading: false,
      showKartraCustomFields: false,
      integrationDetails: {},
      zapier: [""],
      zapierLabels: [""],
      sendTestZapier: false,
      agencyZoomWebhook: [""],
      sendTestAgencyZoom: false,
      // sendjim
      sendjimConnected: false,
      isLoadingConnectDisconnectSendjim: false,
      companyId: '',
      refcode: 'C8GWKU',
      clickfunnels: {
        subdomain: '',
        workspaceId: '',
      },
      windowWidth: window.innerWidth,
      listCustomFieldsIntegration: [],
      isLoadingListCustomFieldsIntegration: false,
      errorListCustomFieldsIntegration: false,
      listValueCustomFieldsIntegration: [],
      listValueCustomFieldsIntegrationB2b: [],
      listValueCustomFieldsIntegrationAdvance: [],
      prevListValueCustomFieldsIntegration: [],
      prevListValueCustomFieldsIntegrationB2b: [],
      prevListValueCustomFieldsIntegrationAdvance: [],
      isHideB2b: false,
      isHideAdvance: false,
      slugName: '',
      integrationCustom: {},
      integrationCustomStatus: {
        loading: false,
        notFound: false,
        error: false,
      },
      isCheckAllIntegrationGeneral: false,
      isCheckAllIntegrationB2b: false,
      isCheckAllIntegrationAdvance: false,
      selects: {
        ghlv2SubAccount: '',
      },
      paginationGhlV2SubAccount: {
        currentPage: 1,
        isComplete: false,
        isFetch: false,
      },
    }
  },
  async created() {
    await this.loadIntegrationDetail()
  },
  computed: {
    isInRootSystemUser() {
      return this.$global.idsys == this.$global.masteridsys;
    },
    isViewModeClientFromRootOrAgency() {
      return (this.$global.globalviewmode || this.$global.globalviewmodeclient);
    },
    labelSSOLinkYourSubAccount() {
      return (!this.$global.globalviewmode && !this.$global.globalviewmodeclient) ? "Agency's Subaccount"  : "Your Subaccount";
    },
    labelSSOLinkYourAccount() {
      return (this.$global.globalviewmode || this.$global.globalviewmodeclient) ? "Client's Account"  : "Your Account";
    },
    sendjimCallbackUrl() {
      return `${process.env.VUE_APP_DATASERVER_URL}/sendjim/oauth/callback/view`;
    },
    isZapierEmpty() {
      return this.zapier.length === 0 || this.zapier.every(item => item.trim() === "");
    },

    isValidConfiguration() {
      const slugName = this.slugName;

      const rules = {
        sendgrid: () => !!this.userApiKey && this.userApiKey.trim() !== '',
        gohighlevel: () => {
          if (this.integrationVersion == 1) {
            return !!this.userApiKey && this.userApiKey.trim() !== '';
          } else {
            return !!this.ghlV2Connected;
          }
        },
        zapier: () => {
          return Array.isArray(this.zapier) &&
                this.zapier.length > 0 &&
                this.zapier.some(key => key && key.trim() !== '');
        },
        mailboxpower: () => !!this.userApiKey && this.userApiKey.trim() !== '',
        kartra: () => !!this.userApiKey && this.userApiKey.trim() !== '' &&
                    !!this.userApiPassword && this.userApiPassword.trim() !== '',
        clickfunnels: () => !!this.userApiKey && this.userApiKey.trim() !== '' &&
                        !!this.clickfunnels.subdomain && this.clickfunnels.subdomain.trim() !== '' &&
                        !!this.clickfunnels.workspaceId && this.clickfunnels.workspaceId.trim() !== ''
      };

      return rules[slugName] ? rules[slugName]() : true;
    }
  },
  mounted() {
    const sidebar = this.$global.clientsidebar
    if (!sidebar['b2b']){
        this.isHideB2b = true;
    }

    if (!sidebar['enhance']){
        this.isHideAdvance = true;
    }

    this.ghlv2GetListSubAccounts();

    window.addEventListener("resize", this.updateWindowWidth);
    window.addEventListener("message", this.handleFeedbackConnectGhlV2); // untuk menerima sinyal/feedback saat connect ghl, dan sistem kita di iframe
  },
  watch: {
    'modals.integrations': function(newValue) {
      this.selects.ghlv2SubAccount = '';
    },
  },
  methods: {
    isShowLeadConnectorIframeSection(section = '') {
      if(section == 1) {
        return (this.ghlV2AgencyConnected) && // agency harus sudah connect
               ((this.isViewModeClientFromRootOrAgency) || (!this.isViewModeClientFromRootOrAgency && this.ghlV2CreatedIframe)) // jika view mode client || client login dan sudah buat iframe
      } else {
        return !this.isViewModeClientFromRootOrAgency // jika tidak view mode client atau client login
      }
    },
    normalizeNameIntegrations() { // untuk menormalisasi name integration
      if(this.slugName == 'gohighlevel'){
        this.integrationCustom.name = 'Lead Connector';
      }
    },
    normalizeSlugIntegrations() { // untuk menormalisasi slug integration
      const slug = this.$route.params.slug
      const map = {
        leadconnector: 'gohighlevel',
      }
      return map[slug] || slug
    },
    async loadIntegrationDetail() {
      const userData = this.$store.getters.userData
      this.companyId = userData.company_id
      const slug = this.normalizeSlugIntegrations() // when slug 'leadconnector', then normalize to 'gohighlevel'
      const payloadCustomIntegration = {
        company_id: userData.company_parent,
        slug: slug
      }

      this.integrationCustomStatus.loading = true;
      this.integrationCustomStatus.error = false;
      this.integrationCustomStatus.notFound = false;

      try {
        const response = await this.getCustomIntegrationsDetail({ data: payloadCustomIntegration });
        this.slugName = response.data.slug;
        this.integrationCustom = response.data;
        this.normalizeNameIntegrations();

        const refCode = response.data.refcode;
        if(refCode){
          const parsedData = JSON.parse(`[${refCode}]`);
          const findRefCode = parsedData.filter(item => item.rootid == this.$global.idsys).map(item => item.refcode)
          this.refcode = findRefCode;
        }
      } catch (error) {
        console.error(error);
        if(error.status_code == 404){
          this.integrationCustomStatus.notFound = true;
        } else {
          this.integrationCustomStatus.error = true;
        }

        return;
      } finally {
        this.integrationCustomStatus.loading = false;
      }    

      this.integrationDetails = await this.getUserIntegrationDetails({ companyID: this.companyId, slug: this.slugName })
      var _integrationDetails = this.integrationDetails;

      //console.log(_integrationDetails);
      this.integrationVersion = "2";
      this.ghlV2Connected = false;
      this.btnConnectDisconnectGhlv2Text = 'Activate Contact Sync';

      // const matchSlug = this.integrationDetails.refcode.find(itemFind => itemFind.slug === this.overideIntegrationSlug);
      // if (matchSlug) {
      //   let parsedData = JSON.parse(`[${matchSlug.referralcode}]`);
      //   if (Array.isArray(parsedData)) {
      //       parsedData.forEach(item => {
      //           if (item.rootid == this.$global.idsys) {
      //               this.refcode = item.refcode;
      //           }
                
      //       });
      //   }
        
      // }

      if(typeof(_integrationDetails.ghlV2CreatedIframe) != 'undefined') {
        this.ghlV2CreatedIframe = _integrationDetails.ghlV2CreatedIframe;
        if(this.ghlV2CreatedIframe === true) {
          this.btnCreateDeleteIframeGhlv2Text = 'Remove SSO Link';
        } else {
          this.btnCreateDeleteIframeGhlv2Text = 'Create SSO Link';
        }
      }

      if(typeof(_integrationDetails.ghlV2CreatedIframeYourAccount) != 'undefined') {
        this.ghlV2CreatedIframeYourAccount = _integrationDetails.ghlV2CreatedIframeYourAccount;
        if(this.ghlV2CreatedIframeYourAccount === true) {
          this.btnCreateDeleteIframeGhlv2TextYourAccount = 'Remove SSO Link';
        } else {
          this.btnCreateDeleteIframeGhlv2TextYourAccount = 'Create SSO Link';
        }
      }

      if (_integrationDetails.data && Array.isArray(_integrationDetails.data)) {
        _integrationDetails.data.forEach(item => {
          this.integrationDetails.enable_sendgrid = item.enable_sendgrid === 1;
          this.userApiKey = item.api_key ? item.api_key : '';
          if(this.slugName === 'kartra'){
            this.userApiPassword = item.password
          }

          if(this.slugName === 'zapier'){
            const result = item.api_key.map(item => item);
            this.zapier = result
            if (item.webhook_labels && Array.isArray(item.webhook_labels)) {
              this.zapierLabels = item.webhook_labels.slice(0, this.zapier.length);
              while (this.zapierLabels.length < this.zapier.length) {
                this.zapierLabels.push('');
              }
            } else {
              this.zapierLabels = new Array(this.zapier.length).fill('');
            }
          }

          if(this.slugName === 'agencyzoom'){
            const result = item.api_key.map(item => item);
            this.agencyZoomWebhook = result
          }

          if(this.slugName === 'clickfunnels'){
            this.clickfunnels.subdomain = item.subdomain;
            this.clickfunnels.workspaceId = item.workspace_id;
          }

          if(this.slugName == 'gohighlevel') {
            if(typeof(item.version) != 'undefined' && (item.version == "1" || item.version == "2")) {
              this.integrationVersion = item.version;
            }
            if(typeof(item.ghlV2Connected) != 'undefined') {
              this.ghlV2Connected = item.ghlV2Connected;
              if(this.ghlV2Connected === true) {
                this.btnConnectDisconnectGhlv2Text = 'Deactivate Contact Sync';
              } else {
                this.btnConnectDisconnectGhlv2Text = 'Activate Contact Sync';
              }
            }
          }
          if(this.slugName == 'sendjim') {
            const connectedFlag = (typeof(item.connected) != 'undefined') ? item.connected : null;
            const tokens = (typeof(item.tokens) != 'undefined') ? item.tokens : '';
            this.sendjimConnected = (connectedFlag !== null) ? !!connectedFlag : !!(tokens && tokens.toString().trim() !== '');
            if (typeof item.api_key !== 'undefined') {
              this.userApiKey = item.api_key || '';
            }
            if (typeof item.password !== 'undefined') {
              this.sendjimClientSecret = item.password || '';
            }
          }
        });
      }else {
        console.error("Integration details not found or not in the expected format.");
      }

      await this.getCustomFields()

      if(_integrationDetails.data && _integrationDetails.data[0].custom_fields){
        const listDisabledCustomFields = (this.listCustomFieldsIntegration || []).filter(item => item.disabled && item.type === 'general').map(item => item.name)
        const customFields = [...listDisabledCustomFields, ..._integrationDetails.data[0].custom_fields]
        
        this.listValueCustomFieldsIntegration = customFields;
      } else {
        this.listValueCustomFieldsIntegration = (this.listCustomFieldsIntegration || []).filter(item => item.type === 'general').map(item => item.name);
      }

      if(_integrationDetails.data && _integrationDetails.data[0].custom_fields_b2b){
        const listDisabledCustomFields = (this.listCustomFieldsIntegration || []).filter(item => item.disabled && item.type === 'b2b').map(item => item.name)
        const customFields = [...listDisabledCustomFields, ..._integrationDetails.data[0].custom_fields_b2b]
        
        this.listValueCustomFieldsIntegrationB2b = customFields;
      } else {
        this.listValueCustomFieldsIntegrationB2b = (this.listCustomFieldsIntegration || []).filter(item => item.type === 'b2b').map(item => item.name);
      }
      
      if(_integrationDetails.data && _integrationDetails.data[0].custom_fields_advance){
        const listDisabledCustomFields = (this.listCustomFieldsIntegration || []).filter(item => item.disabled && item.type === 'advance').map(item => item.name)
        const customFields = [...listDisabledCustomFields, ..._integrationDetails.data[0].custom_fields_advance]
        
        this.listValueCustomFieldsIntegrationAdvance = customFields;
      } else {
        this.listValueCustomFieldsIntegrationAdvance = (this.listCustomFieldsIntegration || []).filter(item => item.type === 'advance').map(item => item.name);
      }

      this.handleDefaultCheckAllCustomFields('General')
      this.handleDefaultCheckAllCustomFields('B2b')
      this.handleDefaultCheckAllCustomFields('Advance')

      // FOR LOGS
      const listDisabledCustomFields = (this.listCustomFieldsIntegration || []).filter(item => item.disabled).map(item => item.name)
      const filteredListGeneral = (this.listValueCustomFieldsIntegration || []).filter(item => !listDisabledCustomFields.includes(item));
      const filteredListB2b = (this.listValueCustomFieldsIntegrationB2b || []).filter(item => !listDisabledCustomFields.includes(item));
      const filteredListAdvance = (this.listValueCustomFieldsIntegrationAdvance || []).filter(item => !listDisabledCustomFields.includes(item));
      this.prevListValueCustomFieldsIntegration = [...filteredListGeneral]
      this.prevListValueCustomFieldsIntegrationB2b = [...filteredListB2b]
      this.prevListValueCustomFieldsIntegrationAdvance = [...filteredListAdvance]
      // FOR LOGS
    },
    async handleFeedbackConnectGhlV2(event) {
      if(event.data.ghl_status === "connected"){
        await this.loadIntegrationDetail();
        const message = event.data.action_type == 'ghl_custom_menus_client_your_account' ? 'Create SSO Link Successfully' : 'Contact Sync Activated Successfully';
        this.$notify({type: 'success', message: message, icon: 'fas fa-save'});
      }
    },
    isInIframe() {
      try {
        return window.self !== window.top;
      } catch (e) {
        // Tidak boleh akses window.top → berarti sedang dalam iframe
        return true;
      }
    },
    copyToClipboard(text) {
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(text)
          .then(() => {
            this.$notify({ type: 'success', message: 'Copied to clipboard', icon: 'far fa-copy' });
          })
          .catch(() => {
            this.$notify({ type: 'danger', message: 'Copy failed', icon: 'fas fa-bug' });
          });
      } else {
        const textArea = document.createElement("textarea");
        textArea.value = text;
        textArea.style.position = "fixed";
        textArea.style.top = "0";
        textArea.style.left = "0";
        textArea.style.opacity = "0";
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        try {
          const successful = document.execCommand('copy');
          if (successful) {
            this.$notify({ type: 'success', message: 'Copied to clipboard', icon: 'far fa-copy' });
          } else {
            this.$notify({ type: 'danger', message: 'Copy failed', icon: 'fas fa-bug' });
          }
        } catch (err) {
          this.$notify({ type: 'danger', message: 'Copy failed', icon: 'fas fa-bug' });
        }
        document.body.removeChild(textArea);
      }
    },
    onViewExampleData() {
      window.open(this.basicExampleDataUrl, "_blank");
    },
    ...mapActions(["saveIntegrationSettings", "getUserIntegrationDetails", 'userLogSaved','getCustomIntegrationsDetail']),
    handleScrollGhlV2SubAccount(event) {
      const dropdown = event.target;
      const tolerant = 2;
      const isFetch = this.paginationGhlV2SubAccount.isFetch;
      const isComplete = this.paginationGhlV2SubAccount.isComplete;
      const totalSubAccounts = this.ghlV2ListSubAccounts.length;
      // console.log({
      //   'function': 'handleScrollGhlV2SubAccount',
      //   'dropdown.scrollTop': dropdown.scrollTop,
      //   'dropdown.clientHeight': dropdown.clientHeight,
      //   'dropdown.scrollTop + dropdown.clientHeight' : dropdown.scrollTop + dropdown.clientHeight,
      //   'dropdown.scrollHeight': dropdown.scrollHeight,
      //   'tolerant': tolerant,
      //   'this.paginationGhlV2SubAccount.isFetch': this.paginationGhlV2SubAccount.isFetch,
      //   'this.paginationGhlV2SubAccount.isComplete': this.paginationGhlV2SubAccount.isComplete
      // })

      if (
        (Math.ceil(dropdown.scrollTop + dropdown.clientHeight) >= dropdown.scrollHeight - tolerant) && // jika scroll sampai bawah
        (!isFetch) && // kondisi harus dalam keadaan tidak fetch list sub account
        (!isComplete) && // pastikan belum semua list sub account diambil
        (totalSubAccounts > 0) // pastikan sebelumnya ada list sub account nya
      ) {
        // console.log('masuk if');
        this.ghlv2GetListSubAccounts();
      }
    },
    onSelectGhlV2SubAccountVisible(visible) {
      if (visible) {
        this.$nextTick(() => {
          const dropdown = this.$refs.selectGhlV2SubAccount.$refs.popper.$el.querySelector('.el-select-dropdown__wrap');
          if (dropdown) {
            dropdown.addEventListener('scroll', this.handleScrollGhlV2SubAccount);
          } else {
            console.error('Dropdown not found');
          }
        });
      }
    },
    
    ghlv2ResetListSubAccounts() {
      this.paginationGhlV2SubAccount.currentPage = 1;
      this.paginationGhlV2SubAccount.isComplete = false;
      this.paginationGhlV2SubAccount.isFetch = false;
      this.ghlV2ListSubAccounts = [];
    },
    ghlv2GetListSubAccounts() {
      if(this.$global.idsys != this.$global.masteridsys) {
        return;
      }

      this.paginationGhlV2SubAccount.isFetch = true;
      this.selects.ghlv2SubAccount = '';
      this
      .$store
      .dispatch('ghlv2GetListSubAccounts', {
        company_id: this.$store.getters.userData.company_parent, // company_id agency
        page: this.paginationGhlV2SubAccount.currentPage, // page sekarang 
      })
      .then(response => {
        // console.log(response);
        this.ghlV2AgencyConnected = response.ghlV2AgencyConnected;
        this.paginationGhlV2SubAccount.isFetch = false;
        this.paginationGhlV2SubAccount.isComplete = (response.listSubAccounts.length == 0);

        if(response.listSubAccounts.length > 0) {
          this.ghlV2ListSubAccounts = [ ...this.ghlV2ListSubAccounts, ...response.listSubAccounts ]
          this.paginationGhlV2SubAccount.currentPage = Number(response.page) + 1;
        }

        // console.log({
        //   'this.ghlV2AgencyConnected': this.ghlV2AgencyConnected,
        //   'this.ghlV2ListSubAccounts': this.ghlV2ListSubAccounts,
        // })
      })
      .catch(error => {
        console.log(error);

        this.paginationGhlV2SubAccount.isFetch = false;

        const message = typeof(error.response.data.message) ? error.response.data.message : 'Something Went Wrong';
        this.$notify({
          type: 'danger',
          icon: 'fas fa-bug',
          message: message
        });
      })
    },
    
    createDeleteIframeGhlv2YourAccount() {
      if(!this.ghlV2CreatedIframeYourAccount) { // create iframe
        this.createIframeGhlv2ClientYourAccount();
      } else { // delete iframe
          this.deleteIframeGhlv2ClientYourAccount();
      }
    },
    createIframeGhlv2ClientYourAccount() {
      MessageBox.prompt('Enter the text that you want to display as your single sign on custom menu link. (30 Characters Max)', 'Enter Your Custom Menu Link Text.', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        inputPattern: /^$|^[a-zA-Z0-9\s]{1,30}$/,
        inputErrorMessage: 'Only letters, numbers, and spaces, max 30 characters',
        inputPlaceholder: '[Client-Name]',
        inputValue: this.$store.getters.userData.company_name,
        customClass: 'message-general-ghl'
      })
      .then(({ value }) => {
        const isInIframe = this.isInIframe();
        this.isLoadingCreateDeleteIframeGhlv2YourAccount = true;
        this.$store.dispatch('createIframeGhlv2ClientYourAccount', {
          company_id: this.$store.getters.userData.company_id,
          subdomain_url: window.location.href,
          custom_menu_name: value,
          user_ip: this.$store.getters.userData.ip_login,
          is_in_iframe: isInIframe
        })
        .then(response => {
          const result = typeof(response.result) != 'undefined' ? response.result : '';
          const url = typeof(response.url) != 'undefined' ? response.url : '';
          // console.log({result, url});

          if(result == 'success' && url != ''){
            if(isInIframe){
              window.open(url, '_blank');
              this.isLoadingCreateDeleteIframeGhlv2YourAccount = false;
            }else{
              window.location.href = url;
            }
          }else{
            this.isLoadingCreateDeleteIframeGhlv2YourAccount = false;
            this.$notify({
              type: 'danger',
              icon: 'fas fa-bug',
              message: 'Something Went Wrong',
            });
          }
        })
        .catch(error => {
          console.error(error);
          this.isLoadingCreateDeleteIframeGhlv2YourAccount = false;

          const message = (typeof(error.response.data.message) != 'undefined') ? error.response.data.message : 'Something Went Wrong';
          this.$notify({
            type: 'danger',
            icon: 'fas fa-bug',
            message: message,
          });
        })
      });
    },
    deleteIframeGhlv2ClientYourAccount() {
      MessageBox.confirm('Are you sure you want to remove SSO link?', 'Warning', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'Cancel',
        type: 'warning',
      })
      .then(result => {
        this.isLoadingCreateDeleteIframeGhlv2YourAccount = true;
        this.$store.dispatch('deleteIframeGhlv2ClientYourAccount', {
          company_id: this.$store.getters.userData.company_id,
          user_ip: this.$store.getters.userData.ip_login
        })
        .then(response => {
          this.isLoadingCreateDeleteIframeGhlv2YourAccount = false;
          this.ghlV2CreatedIframeYourAccount = false;
          this.btnCreateDeleteIframeGhlv2TextYourAccount = 'Create SSO Link';
          this.$notify({
            type: 'success',
            icon: 'fas fa-save',
            message: 'Custom Menu Link Successfully Removed'
          });
        })
        .catch(error => {
          this.isLoadingCreateDeleteIframeGhlv2YourAccount = false;
          const message = typeof(error.response.data.message) != 'undefined' ? error.response.data.message : 'Something Went Wrong';
          this.$notify({
            type: "primary",
            message: message,
            icon: "fas fa-bug"
          });
        })
      });
    },
    
    createDeleteIframeGhlv2() {
      if(!this.ghlV2CreatedIframe) { // create iframe
        this.createIframeGhlv2Client();
      } else { // delete iframe
        this.deleteIframeGhlv2Client();
      }
    },
    createIframeGhlv2Client() {
      if(!this.selects.ghlv2SubAccount) {
        this.$notify({
          type: 'danger',
          message: 'Please select sub accounts',
          icon: 'fas fa-bug'
        });
        return;
      }

      MessageBox.prompt('Enter the text that you want to display as your single sign on custom menu link. (30 Characters Max)', 'Enter Your Custom Menu Link Text.', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        inputPattern: /^$|^[a-zA-Z0-9\s]{1,30}$/,
        inputErrorMessage: 'Only letters, numbers, and spaces, max 30 characters',
        inputPlaceholder: '[Client-Name]',
        inputValue: this.$store.getters.userData.company_name,
        customClass: 'message-general-ghl'
      })
      .then(({ value }) => {
        this.isLoadingCreateDeleteIframeGhlV2 = true;
        this
        .$store
        .dispatch('createIframeGhlv2Client', {
          company_id: this.$store.getters.userData.company_id,
          company_parent: this.$store.getters.userData.company_parent,
          custom_menu_name: value,
          user_ip: this.$store.getters.userData.ip_login,
          location_id: this.selects.ghlv2SubAccount,
        })
        .then(response => {
          // console.log(response);
          this.isLoadingCreateDeleteIframeGhlV2 = false;
          this.ghlV2CreatedIframe = true;
          this.btnCreateDeleteIframeGhlv2Text = 'Remove SSO Link';
          
          this.ghlv2ResetListSubAccounts();
          this.ghlv2GetListSubAccounts();

          this.$notify({
            type: 'success',
            icon: 'fas fa-save',
            message: 'create sso link successfully'
          });
        })
        .catch(error => {
          console.error(error);
          this.isLoadingCreateDeleteIframeGhlV2 = false;
          const message = typeof(error.response.data.message) != 'undefined' ? error.response.data.message : 'Something Wrong';
          this.$notify({
            type: 'danger',
            icon: 'fas fa-bug',
            message: message
          });
        })
      });
    },
    deleteIframeGhlv2Client() {
      MessageBox.confirm('Are you sure you want to remove SSO link?', 'Warning', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'Cancel',
        type: 'warning',
      })
      .then(result => {
        this.isLoadingCreateDeleteIframeGhlV2 = true;
        this
        .$store
        .dispatch('deleteIframeGhlv2Client', {
          company_id: this.$store.getters.userData.company_id,
          company_parent: this.$store.getters.userData.company_parent,
          user_ip: this.$store.getters.userData.ip_login
        })
        .then(response => {
          this.isLoadingCreateDeleteIframeGhlV2 = false;
          this.ghlV2CreatedIframe = false;
          this.btnCreateDeleteIframeGhlv2Text = 'Create SSO Link';
          
          this.ghlv2ResetListSubAccounts();
          this.ghlv2GetListSubAccounts();
          
          this.$notify({
            type: 'success',
            icon: 'fas fa-save',
            message: 'Custom Menu Link Successfully Removed'
          });
        })
        .catch(error => {
          this.isLoadingCreateDeleteIframeGhlV2 = false;
          const message = typeof(error.response.data.message) != 'undefined' ? error.response.data.message : 'Something Wrong';
          this.$notify({
            type: 'danger',
            icon: 'fas fa-bug',
            message: message
          });
        });
      })
    },


    connectDisconnectGhlv2() {
      if(!this.ghlV2Connected) { // connect
        this.generateGHLv2AuthUrl();
      } else { // disconnect
        MessageBox.confirm('Are You Sure Deactivate Contact Sync', 'Warning', {
          confirmButtonText: 'Yes',
          cancelButtonText: 'Cancel',
          type: 'warning'
        })
        .then(() => {
          this.disconnectGhlv2();
        })
        .catch(() => {
          return;
        });
      }
  },
  disconnectGhlv2() {
    this.btnConnectDisconnectGhlv2Text = "Deactivate Contact Sync...";
    $('#btnConnectDisconnectGhlv2').attr('disabled',true);   
    
    this.$store
        .dispatch('disconnectGhlv2', {
          company_id: this.companyId,
          user_ip: this.$store.getters.userData.ip_login
        })
        .then(response => {
          this.ghlV2Connected = false;
          this.btnConnectDisconnectGhlv2Text = "Activate Contact Sync"

          if(typeof(this.integrationDetails.enable_sendgrid) != 'undefined') {
            this.integrationDetails.enable_sendgrid = typeof(response.enable_sendgrid) != 'undefined' ? response.enable_sendgrid : false;
          }
          $('#btnConnectDisconnectGhlv2').attr('disabled',false);

          this.$notify({
            type: "success",
            message: "Deactivate Contact Sync Successfully",
            icon: "fas fa-save"
          });
        })
        .catch(error => {
          this.ghlV2Connected = false;
          this.btnConnectDisconnectGhlv2Text = "Activate Contact Sync"
          $('#btnConnectDisconnectGhlv2').attr('disabled',false);

          this.$notify({
            type: "primary",
            message: error.response.data.message,
            icon: "fas fa-bug"
          });
        });
    },
    generateGHLv2AuthUrl() {
      MessageBox.confirm('Confirm your updates. Unchecked fields will now stop sending this data to your CRM and checked fields will now create this custom field in your CRM, and start sending this data.', 'Warning', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'Cancel',
        type: 'warning'
      })
      .then(() => {
        const isInIframe = this.isInIframe();
        const { filteredListGeneral, filteredListB2b , filteredListAdvance } = this.handleFilterListCustomFields()

        this.isLoadingConnectDisconnectGhlv2 = true;
        this.$store
            .dispatch('generateGHLv2AuthUrl', {
              company_id: this.companyId,
              enable_sendgrid: this.integrationDetails.enable_sendgrid ? 1 : 0,
              subdomain_url: window.location.href,
              custom_fields_general: filteredListGeneral,
              custom_fields_b2b: filteredListB2b,
              custom_fields_advance: filteredListAdvance,
              user_ip: this.$store.getters.userData.ip_login,
              is_in_iframe: isInIframe
            })
            .then(response => {
              const result = typeof(response.result) != 'undefined' ? response.result : '';
              const url = typeof(response.url) != 'undefined' ? response.url : '';
              // console.log({result, url});
              
              if(result == 'success' && url != ''){
                if(isInIframe){
                  this.isLoadingConnectDisconnectGhlv2 = false;
                  window.open(url, '_blank');
                }else{
                  window.location.href = url;
                }
              }
            })
            .catch(error => {
              this.isLoadingConnectDisconnectGhlv2 = false;
              console.log(error);
            })
      })
      .catch(() => {
        return;
      });
    },
    async connectSendJim() {
      if(!this.userApiKey || this.userApiKey.trim() === '') {
        this.$notify({ type: 'danger', message: 'Please enter your SendJim Client ID first', icon: 'fas fa-bug' });
        return;
      }
      if(!this.sendjimClientSecret || this.sendjimClientSecret.trim() === '') {
        this.$notify({ type: 'danger', message: 'Please enter your SendJim Client Secret first', icon: 'fas fa-bug' });
        return;
      }
      // Ensure credentials are saved before generating auth URL
      try {
        this.isLoadingConnectDisconnectSendjim = true;
        await this.saveIntegrationSettingslocal();
      } catch (e) {}
        this.isLoadingConnectDisconnectSendjim = true;
      try {
        const resp = await this.$store.dispatch('generateSendJimAuthUrl', {
          company_id: this.companyId,
          subdomain_url: window.location.href,
          user_ip: this.$store.getters.userData.ip_login,
          client_id: this.userApiKey,
        });
        const url = resp && resp.url ? resp.url : '';
        if(url) window.location.href = url;
      } catch (e) {
        this.$notify({ type: 'primary', message: 'Failed to start OAuth', icon: 'fas fa-bug' });
      } finally {
        this.isLoadingConnectDisconnectSendjim = false;
      }
    },
    async disconnectSendJim() {
      this.isLoadingConnectDisconnectSendjim = true;
      try {
        await this.$store.dispatch('disconnectSendJim', { company_id: this.companyId, user_ip: this.$store.getters.userData.ip_login });
        this.sendjimConnected = false;
        this.$notify({ type: 'success', message: 'Disconnected SendJim', icon: 'far fa-save' });
      } catch (e) {
        this.$notify({ type: 'primary', message: 'Failed to disconnect', icon: 'fas fa-bug' });
      } finally {
        this.isLoadingConnectDisconnectSendjim = false;
      }
    },
    validateConfiguration(data) {
      // console.log('validateConfiguration', { data });
      const notifyError = (message) => {
        this.$notify({
          type: 'primary',
          icon: 'fas fa-exclamation-circle',
          message
        });
      };

      const rules = {
        sendgrid: () => {
          if (!data.api_key || data.api_key.trim() === '') {
            notifyError('API Key is required');
            return false;
          }
          return true;
        },
        gohighlevel: () => {
          const version = this.integrationVersion;
          if (version == 1) {
            if (!data.api_key || data.api_key.trim() === '') {
              notifyError('API Key is required');
              return false;
            }
          } else {
            if (!this.ghlV2Connected) {
              notifyError('Please connect account first');
              return false;
            }
          }
          return true;
        },
        zapier: () => {
          if (
            !Array.isArray(data.api_key) ||
            data.api_key.length === 0 ||
            data.api_key.some(key => !key || key.trim() === '')
          ) {
            notifyError('Url is required');
            return false;
          }
          return true;
        },
        mailboxpower: () => {
          if (!data.api_key || data.api_key.trim() === '') {
            notifyError('API Key is required');
            return false;
          }
          return true;
        },
        kartra: () => {
          if (!data.api_key || data.api_key.trim() === '') {
            notifyError('API Key is required');
            return false;
          }
          if (!data.password || data.password.trim() === '') {
            notifyError('Password is required');
            return false;
          }
          return true;
        },
        agencyzoom: () => {
          if (
            !Array.isArray(data.api_key) ||
            data.api_key.length === 0 ||
            data.api_key.some(key => !key || key.trim() === '')
          ) {
            notifyError('Url is required');
            return false;
          }
          return true;
        },
      };

      if (rules[data.integration_slug]) {
        return rules[data.integration_slug]();
      }

      return true;
    },
    async saveIntegrationSettingslocal() {
      $('#btnSaveIntegration').html('Saving...');   
      this.isLoading = true
      let data = {
        integration_slug: this.slugName,
        company_id: this.companyId,
        api_key: this.userApiKey,
        enable_sendgrid: this.integrationDetails.enable_sendgrid ? 1 : 0,
        enable_default_campaign: 0,
      }
      if (this.slugName == 'sendjim') {
        if(!this.userApiKey || this.userApiKey.trim() === '') {
          this.$notify({ type: 'danger', message: 'Client ID is required', icon: 'fas fa-bug' });
          $('#btnSaveIntegration').html('Save');
          this.isLoading = false
          return;
        }
        if(!this.sendjimClientSecret || this.sendjimClientSecret.trim() === '') {
          this.$notify({ type: 'danger', message: 'Client Secret is required', icon: 'fas fa-bug' });
          $('#btnSaveIntegration').html('Save');
          this.isLoading = false
          return;
        }
        data.password = this.sendjimClientSecret;
      }

      if (this.slugName == 'kartra') {
        data.password = this.userApiPassword;
      }
      if (this.slugName == 'gohighlevel') {
        try {
          await MessageBox.confirm('Confirm your updates. Unchecked fields will now stop sending this data to your CRM and checked fields will now create this custom field in your CRM, and start sending this data.', 'Warning', {
            confirmButtonText: 'Yes',
            cancelButtonText: 'Cancel',
            type: 'warning'
          });

        } catch (error) {
          $('#btnSaveIntegration').html('Save');
          this.isLoading = false
          return;
        }

        const { filteredListGeneral, filteredListB2b , filteredListAdvance } = this.handleFilterListCustomFields()
        
        data.version = this.integrationVersion;
        data.custom_fields = filteredListGeneral;
        data.custom_fields_b2b = filteredListB2b;
        data.custom_fields_advance = filteredListAdvance;
      }
      if (this.slugName === 'zapier') {
        data.send_test_zapier = this.sendTestZapier
        const validWebhookUrls = this.zapier.filter(item => !item || item.trim() != "");
        data.api_key = validWebhookUrls
        const validLabels = this.zapierLabels.slice(0, validWebhookUrls.length).map((label, idx) => {
          return (label || '').trim();
        });
        data.webhook_labels = validLabels
      }
      if (this.slugName === 'clickfunnels') {
        try {
          await MessageBox.confirm('Confirm your updates. Unchecked fields will now stop sending this data to your CRM and checked fields will now create this custom field in your CRM, and start sending this data.', 'Warning', {
            confirmButtonText: 'Yes',
            cancelButtonText: 'Cancel',
            type: 'warning'
          });
        } catch (error) {
          $('#btnSaveIntegration').html('Save');
          this.isLoading = false
          return;
        }
        
        data.subdomain = this.clickfunnels.subdomain;
        data.workspace_id = this.clickfunnels.workspaceId;

        const { filteredListGeneral, filteredListB2b } = this.handleFilterListCustomFields()
        
        data.custom_fields = filteredListGeneral;
        data.custom_fields_b2b = filteredListB2b;
      }
      if (this.slugName === 'agencyzoom') {
        data.send_test_agency_zoom = this.sendTestAgencyZoom
        data.api_key = this.agencyZoomWebhook;
      }

      if (!this.validateConfiguration(data)) {
        $('#btnSaveIntegration').html('Save');
        this.isLoading = false 
        return;
      }

      const response = await this.saveIntegrationSettings({ data })

      // FOR LOGS
      if(response.result == 'success'){
          const userData = this.$store.getters.userData;
          
          // for first time enable
          if(typeof(response.enable_sendgrid) != 'undefined') {
            this.integrationDetails.enable_sendgrid = response.enable_sendgrid;
          }
          // for first time enable
          
          if(this.slugName === 'clickfunnels' || this.slugName === 'gohighlevel'){
              let desc = `Company Id: ${this.companyId} | Integration Type: ${this.slugName} | `;

              const appendDescription = (field, prevValue, newValue) => {
                  desc += `${field} : Update values from ${prevValue || 'Empty'} to: ${newValue || 'Empty'} | `;
              };
              const joinArray = (arr) => (arr && arr.length > 0 ? arr.join(', ') : 'Empty');

              const isChangedCustomFields = this.hasChangedArray(this.prevListValueCustomFieldsIntegration, data.custom_fields)
              const isChangedCustomFieldsB2b = this.hasChangedArray(this.prevListValueCustomFieldsIntegrationB2b, data.custom_fields_b2b)
              const isChangedCustomFieldsAdvance = this.hasChangedArray(this.prevListValueCustomFieldsIntegrationAdvance, data.custom_fields_advance)

              if(isChangedCustomFields){
                  appendDescription(
                      "Custom Fields",
                      joinArray(this.prevListValueCustomFieldsIntegration),
                      joinArray(data.custom_fields)
                  );
                  
                  desc += `The user has confirmed and agreed to this action.`;
              } else {
                  desc += `Custom Fields : No changes, value remains ${joinArray(data.custom_fields)}`;
              }

              if(isChangedCustomFieldsB2b){
                  appendDescription(
                      " | Custom Fields B2B",
                      joinArray(this.prevListValueCustomFieldsIntegrationB2b),
                      joinArray(data.custom_fields_b2b)
                  );
                  
                  desc += `The user has confirmed and agreed to this action.`;
              } else {
                  desc += ` | Custom Fields B2B : No changes, value remains ${joinArray(data.custom_fields)}`;
              }

              if(isChangedCustomFieldsAdvance){
                  appendDescription(
                      " | Custom Fields Enhance Advance",
                      joinArray(this.prevListValueCustomFieldsIntegrationAdvance),
                      joinArray(data.custom_fields_advance)
                  );
                  
                  desc += `The user has confirmed and agreed to this action.`;
              } else {
                  desc += ` | Custom Fields Enhance Advance : No changes, value remains ${joinArray(data.custom_fields)}`;
              }

              // const payload = {
              //     userID: userData.id,
              //     action: "Custom Fields",
              //     desc,
              //     userIP: this.$store.getters.userData.ip_login,
              // }
              // const userViewMode = userData.isViewMode ? userData.isViewMode : false;
              // if(userViewMode){
              //     const userRoot = await decryptData(localStorage.getItem('userDataOri'))
              //     payload.userID = userRoot.id;
              // }
              // this.userLogSaved({ data: payload });
              this.$store.dispatch('onSaveUserLogs', {
                  desc: desc,
                  action: "Custom Fields",
                  target_id: userData.id,
              })

              this.prevListValueCustomFieldsIntegration = data.custom_fields;
          }
      }
      // FOR LOGS

      $('#btnSaveIntegration').html('Save');
      this.isLoading = false
    },
    addWebhookUrl(type) {
      if (type == 'zapier') {
        this.zapier.push('');
        this.zapierLabels.push('');
      } else if (type == 'agencyzoom') {
        this.agencyZoomWebhook.push('');
      }
    },
    addWebhookUrlKeyupEnter(event, type) {
      if (event.key === "Enter") {
        this.addWebhookUrl(type);
      }
    },
    removeWebhookUrl(index, type) {
        if (type == 'zapier') {
          if (this.zapier.length > 1) {
            this.zapier.splice(index, 1);
            this.zapierLabels.splice(index, 1);
          }
        } else if (type == 'agencyzoom') {
          if (this.agencyZoomWebhook.length > 1) {
            this.agencyZoomWebhook.splice(index, 1);
          }
        }
    },
    async getCustomFields(){
      this.isLoadingListCustomFieldsIntegration = true;
      this.errorListCustomFieldsIntegration = false;

      const payload = {
        slug: this.slugName,
      }

      await this.$store.dispatch('getCustomFieldsBySlug', payload).then(response => {
          this.listCustomFieldsIntegration = response.data.custom_fields;
          this.isLoadingListCustomFieldsIntegration = false;
      }).catch(error => {
          this.errorListCustomFieldsIntegration = true;
          this.isLoadingListCustomFieldsIntegration = false;
      })
    },
    handleCheckItemCustomFields(type, name, module){
        const handleModule = () => {
          switch (module) {
            case 'b2b':
              return 'B2b';
            case 'advance':
              return 'Advance'
            default:
              return ''
          }
        }

        const listValueIntegration = this[`listValueCustomFieldsIntegration${handleModule()}`];
        const isChecked = listValueIntegration.includes(name);

        const listAll = this.listCustomFieldsIntegration.filter(item => item.type === module);

        MessageBox.confirm(
            isChecked 
                ? `Unchecking "${name}" will stop sending this data to your CRM. Are you sure?` 
                : `Checking "${name}" will create this custom field in your CRM, and start sending this data. Are your sure?`,
            'Warning',
            {
                confirmButtonText: 'Yes',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }
        ).then(() => {
            const capitalizedModule = module.charAt(0).toUpperCase() + module.slice(1);

            if (isChecked) {
                this[`listValueCustomFieldsIntegration${handleModule()}`] = listValueIntegration.filter(item => item !== name);
                this[`isCheckAllIntegration${capitalizedModule}`] = false;
            } else {
                this[`listValueCustomFieldsIntegration${handleModule()}`].push(name);
                if(this[`listValueCustomFieldsIntegration${handleModule()}`].length === listAll.length){
                  this[`isCheckAllIntegration${capitalizedModule}`] = true;
                }
            }
        }).catch(() => {
            return;
        });
    },
    hasChangedArray(prevData, currentData){

        if(prevData == undefined || currentData == undefined){
          return true;
        }

        if (prevData.length !== currentData.length) {
            return true;
        }

        // Check each element in the array
        for (let i = 0; i < prevData.length; i++) {
            if (prevData[i] !== currentData[i]) {
                return true; // Return true if any element is different
            }
        }

        // Return false if all elements are the same
        return false;
    },
    getCustomFieldsByType(type, fields, filteredList) {
        const listCustomFields = fields
            .filter(item => item.type === type)
            .map(item => item.name);

        return filteredList.filter(item => listCustomFields.includes(item));
    },
    handleFilterListCustomFields() {
      const listDisabledCustomFields = this.listCustomFieldsIntegration.filter(item => item.disabled).map(item => item.name)
      const filteredListGeneral = this.listValueCustomFieldsIntegration.filter(item => !listDisabledCustomFields.includes(item));
      const filteredListB2b = this.listValueCustomFieldsIntegrationB2b.filter(item => !listDisabledCustomFields.includes(item));
      const filteredListAdvance = this.listValueCustomFieldsIntegrationAdvance.filter(item => !listDisabledCustomFields.includes(item));

      return { filteredListGeneral, filteredListB2b, filteredListAdvance }
    },
    updateWindowWidth() {
        this.windowWidth = window.innerWidth;
    },
    async handleCheckAllCustomFields(value, slug, type){
      const capitalizedModule = type.charAt(0).toUpperCase() + type.slice(1);
      const rewriteType = capitalizedModule == 'General' ? '' : capitalizedModule;

      const listAll = this.listCustomFieldsIntegration.filter(item => item.type === type)
      .map(item => item.name);
      const listDisabledCustomFields = this.listCustomFieldsIntegration.filter(item => item.disabled && item.type === type).map(item => item.name)

      await MessageBox.confirm(
          !value 
              ? `Unchecking "all" will stop sending this data to your CRM. Are you sure?` 
              : `Checking "all" will create this custom field in your CRM, and start sending this data. Are your sure?`,
          'Warning',
          {
              confirmButtonText: 'Yes',
              cancelButtonText: 'Cancel',
              type: 'warning'
          }
      ).then(() => {
          if (value) {
            this[`listValueCustomFieldsIntegration${rewriteType}`] = listAll;
            this[`isCheckAllIntegration${capitalizedModule}`] = true;
          } else {
            this[`listValueCustomFieldsIntegration${rewriteType}`] = listDisabledCustomFields;
            this[`isCheckAllIntegration${capitalizedModule}`] = false;
          }
      }).catch(() => {
          return;
      });
    },
    handleDefaultCheckAllCustomFields(type, slug){
      const rewriteType = type == 'General' ? '' : type;
      const listAll = this.listCustomFieldsIntegration.filter(item => item.type === type.toLowerCase())
      .map(item => item.name);
      const listValue = this[`listValueCustomFieldsIntegration${rewriteType}`];

      if(listAll.length == listValue.length){
        this[`isCheckAllIntegration${type}`] = true;
      } else {
        this[`isCheckAllIntegration${type}`] = false;
      }
    },
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateWindowWidth);
    window.removeEventListener("message", this.handleFeedbackConnectGhlV2); // untuk menerima sinyal/feedback saat connect ghl, dan sistem kita di iframe

    // hapus event scroll dari select sub account ghl 
    const dropdown = this.$refs.selectGhlV2SubAccount.$refs.popper.$el.querySelector('.el-select-dropdown__wrap');
    if (dropdown) {
      dropdown.removeEventListener('scroll', this.handleScrollGhlV2SubAccount);
    }
  }
};
</script>

<style scoped>
/* FOR DIVIDER IN GHL VERSION 2 */
.divider-ghl2 {
  border-top: 1px solid #dcdfe6;
  padding-top: 1rem;
  margin-top: 1rem;
  margin-left: 0px;
  border-left: none;
}
@media (min-width: 768px) {
  .divider-ghl2 {
    border-left: 1px solid #dcdfe6;
    border-top: none;
    padding-top: 0;
    margin-top: 0;
    margin-left: -2px;
  }
}
/* FOR DIVIDER IN GHL VERSION 2 */
</style>

<style>
.add-webhook-url{
    height: 40px;
    width: 40px;
    background: gray;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    cursor: pointer;
    color: white;
}
.webhook-url-wrapper{
    display: flex;
    align-items: center;
    gap: 4px;
    margin-bottom: 4px;
}

.integration-webhook-section {
    width: 100%;
    padding: 16px 18px;
    border-radius: 10px;
    border: 1px solid rgba(15, 23, 42, 0.08);
    background: #f8fafc;
    box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
    margin-top: 12px;
}

:root.dark-theme .integration-webhook-section {
    background: var(--background-color-secondary) !important;
    border-color: var(--card-border-color) !important;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2) !important;
}

.integration-webhook-section__header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 16px;
    margin-bottom: 12px;
}

.integration-webhook-section__title {
    font-size: 15px;
    font-weight: 600;
    margin-bottom: 2px;
    color: #222a42 !important;
}

:root.dark-theme .integration-webhook-section__title {
    color: var(--text-primary-color) !important;
}

.integration-webhook-section__subtitle {
    font-size: 12px;
    margin: 0;
    color: #64748b;
}

:root.dark-theme .integration-webhook-section__subtitle {
    color: var(--accent-color) !important;
}

.integration-webhook-section__body {
    margin-top: 8px;
}

.integration-webhook-section__label {
    display: block;
    font-size: 12px;
    font-weight: 500;
    margin-bottom: 2px;
    color: #222a42;
}

:root.dark-theme .integration-webhook-section__label {
    color: var(--text-primary-color) !important;
}

.integration-webhook-section__helper {
    font-size: 11px;
    color: #64748b;
    margin-bottom: 8px;
}

:root.dark-theme .integration-webhook-section__helper {
    color: var(--accent-color) !important;
}

.integration-webhook-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.integration-webhook-item {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 8px;
    width: 100%;
}

.integration-webhook-item__main {
    display: flex;
    align-items: center;
    gap: 8px;
    flex: 1;
}

.integration-webhook-item__badge {
    min-width: 24px;
    height: 24px;
    border-radius: 999px;
    background: #e2e8f0;
    color: #0f172a;
    font-size: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
}

:root.dark-theme .integration-webhook-item__badge {
    background: var(--muted) !important;
    color: var(--text-primary-color) !important;
}

.integration-webhook-item__input {
    width: 100%;
    flex: 1;
}

:root.dark-theme .integration-webhook-item__input .el-input__inner {
    background-color: var(--background-color-primary) !important;
    border-color: var(--card-border-color) !important;
    color: var(--primary-input-text-color) !important;
}

:root.dark-theme .integration-webhook-item__input .el-input__inner:focus {
    border-color: var(--btn-primary-color) !important;
}

.integration-webhook-item__fields {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
    width: 100%;
}

.integration-webhook-item__label-input {
    flex: 1;
    font-size: 11px;
}

:root.dark-theme .integration-webhook-item__label-input .el-input__inner {
    background-color: var(--background-color-primary) !important;
    border-color: var(--card-border-color) !important;
    color: var(--primary-input-text-color) !important;
}

:root.dark-theme .integration-webhook-item__label-input .el-input__inner:focus {
    border-color: var(--btn-primary-color) !important;
}

.integration-webhook-item__actions {
    display: flex;
    align-items: center;
    justify-content: flex-end;
}

:root.dark-theme .integration-webhook-item__actions .el-button--text {
    color: var(--text-primary-color) !important;
}

:root.dark-theme .integration-webhook-item__actions .el-button--text:hover {
    color: var(--btn-primary-color) !important;
}

.integration-webhook-section__footer {
    margin-top: 10px;
    display: flex;
    justify-content: flex-end;
}

:root.dark-theme .integration-webhook-section__footer .el-button--primary {
    background-color: var(--btn-primary-color) !important;
    border-color: var(--btn-primary-color) !important;
}

:root.dark-theme .integration-webhook-section__footer .el-button--primary:hover {
    background-color: var(--btn-primary-hover-color) !important;
    border-color: var(--btn-primary-hover-color) !important;
}

/* Dark mode untuk text di integration webhook section */
:root.dark-theme .integration-webhook-section ~ .m-0,
:root.dark-theme .integration-webhook-section ~ div .m-0 {
    color: var(--text-primary-color) !important;
}

:root.dark-theme .integration-webhook-section ~ div .m-0 a {
    color: var(--link-color) !important;
}

:root.dark-theme .integration-webhook-section ~ div .m-0 a:hover {
    color: var(--btn-primary-color) !important;
}

/* Dark mode untuk checkbox dan button di bawah integration webhook section */
:root.dark-theme .integration-webhook-section ~ .d-flex .el-checkbox__label {
    color: var(--text-primary-color) !important;
}

:root.dark-theme .integration-webhook-section ~ .d-flex .el-button--text {
    color: var(--text-primary-color) !important;
}

:root.dark-theme .integration-webhook-section ~ .d-flex .el-button--text:hover {
    color: var(--btn-primary-color) !important;
}

.input__transparent .el-input__inner {
  background-color: transparent !important;
  color: var(--primary-input-text-color);
}

.checkbox-custom-fields-integrations {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
}

.checkbox-custom-fields-integrations .el-checkbox__input.is-focus .el-checkbox__inner {
    border-color: var(--btn-primary-color);
}

.checkbox-custom-fields-integrations .el-checkbox__inner {
    border-color: var(--btn-primary-color);
    background-color: transparent;
    border-radius: 3px;
}

.checkbox-custom-fields-integrations .el-checkbox__inner:hover {
    border-color: var(--btn-primary-color);
}

.checkbox-custom-fields-integrations .el-checkbox__input.is-checked+.el-checkbox__label {
    color: var(--text-primary-color);
}

.checkbox-custom-fields-integrations .el-checkbox__input.is-checked .el-checkbox__inner {
    border-color: var(--btn-primary-color);
    background-color: var(--btn-primary-color);
    border-radius: 3px;
}

.checkbox-custom-fields-integrations .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    border-color: var(--btn-primary-color);
    background-color: var(--btn-primary-color);
}

.checkbox-custom-fields-integrations .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {
  opacity: 0.6;
}

.checkbox-custom-fields-integrations .el-checkbox__input.is-disabled+span.el-checkbox__label {
  opacity: 0.6;
}

.error-banner {
    padding: 8px 16px;
    background-color: #ffe6e6; /* Light red background for error */
    border-radius: 4px;
    border-left: 5px solid #dc3545; /* Red border for error */
    margin: 20px 0;
    font-size: 14px;
    color: #721c24; /* Darker red text for readability */
    line-height: 1.5em;
}

.error-banner p {
    margin: 0;
}

.leadconnector-theme {
  background-color: var(--background-color-secondary);
  color: var(--accent-color);
}

@media (max-width: 768px) {
  .checkbox-custom-fields-integrations {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 469px) {
    .checkbox-custom-fields-integrations {
        grid-template-columns: repeat(1, 1fr); 
    }
}
</style>